module.exports = __webpack_public_path__ + "static/media/MHRM39N0012.3135eeb9.svg";